import { IEventFlat } from "../domain/models/Events";
import { BaseModelImpl } from "./BaseModelImpl";
import { Location } from "../domain/enums/LocationEnum";
import { Format } from "../domain/enums/FormatEnum";

export class EventsFlatModel extends BaseModelImpl<IEventFlat> implements IEventFlat {
    id: string;

    title: string;
    subtitle: string;
    description: string;
    languageCode: string;

    eventDate: Date;
    location: Location;
    format: Format;

    creatorId: string;
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: IEventFlat) {
        super();
        this.assignData(data);
    }
}


